import { render, staticRenderFns } from "./DayplannerSidebar.vue?vue&type=template&id=2c125ed7&"
import script from "./DayplannerSidebar.vue?vue&type=script&lang=js&"
export * from "./DayplannerSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DayplannerSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports